<template>
  <v-card class="mt-4 mb-3">
      <v-img class="image-cropper-galleryphoto" :src="imgURL"/>
    <v-spacer></v-spacer>
    <v-card-title v-if="caption" class="justify-center custom-font" style="font-size: large">
    {{ caption }}
    </v-card-title>
  </v-card>
</template>

<script>
export default {
  props: ["imgURL", "caption"],
};
</script>

<style>
.card-size-gallery {
  width: 100%;
  margin-top: 2rem;
  margin-left: 2rem;
  margin-bottom: 2rem;
  margin-right: 2rem;
  padding: 2rem;
}

.image-cropper-galleryphoto {
  width: 400px;
  height: auto;
  max-height: 500px;
  object-fit: cover;
  
}
</style>
